// Vendors
import React, { createContext, PropsWithChildren, useContext, useState } from 'react';
// Types
import { AuthContextType, AuthDataResponseType } from './types/auth.context.type';

const AuthContext = createContext<AuthContextType>({} as AuthContextType);

const AuthContextProvider = ({ children }: PropsWithChildren): React.ReactElement => {
  const [authData, setAuthData] = useState<AuthDataResponseType>({});

  return <AuthContext.Provider value={{ authData, setAuthData }}>{children}</AuthContext.Provider>;
};

const useAuthContextConsumerHook = (): AuthContextType => useContext(AuthContext);

export { useAuthContextConsumerHook, AuthContextProvider };
